import { t } from "i18next";
import moment from "moment";

export const formatDateRange = (
  startDatetime,
  endDatetime,
  formatStartDatetime = "YYYY-MM-DD HH:mm:ss",
  formatEndDatetime = "YYYY-MM-DD HH:mm:ss",
  withSpace = false
) => {
  const mesi = t("calendar.abbr_months", { returnObjects: true });

  const startDate = moment(startDatetime, formatStartDatetime);
  const endDate = moment(endDatetime, formatEndDatetime);

  function formatDatetime(date, withSpace = false) {
    return `${date.date()} ${mesi[date.month()]} ${date.year()} ${
      withSpace ? "\n" : ""
    }${date.format("HH:mm") !== "00:00" ? date.format("HH:mm") : ""}`;
  }

  if (!withSpace) {
    if (startDate.isSame(endDate, "day")) {
      return (
        formatDatetime(startDate) +
        (endDate.format("HH:mm") !== "00:00"
          ? " - " + endDate.format("HH:mm")
          : "")
      );
    } else {
      return formatDatetime(startDate) + " - " + formatDatetime(endDate);
    }
  } else {
    if (startDate.isSame(endDate, "day")) {
      return (
        formatDatetime(startDate, true) +
        (endDate.format("HH:mm") !== "00:00"
          ? " - " + endDate.format("HH:mm")
          : "")
      );
    } else {
      return (
        "Da " + formatDatetime(startDate) + "\na " + formatDatetime(endDate)
      );
    }
  }
};
